import {
  distance,
  Feature,
  Geometry,
  LineString,
  MultiLineString,
  nearestPointOnLine,
  pointToLineDistance,
  Polygon,
  polygonToLineString,
  Position,
  Units,
} from "@turf/turf";

export function distanceHelper(
  from: Position,
  to: Geometry,
  units?: Units,
): number {
  if (to?.type === "Point") {
    return distance(from, to.coordinates as Position, {
      units: units || "miles",
    });
  }
  if (to?.type === "LineString") {
    return pointToLineDistance(from, to as LineString, {
      units: units || "miles",
    });
  }

  if (to?.type === "MultiLineString") {
    const newTo = nearestPointOnLine(to as MultiLineString, from, {
      units: units || "miles",
    });
    return distance(from, newTo, {
      units: units || "miles",
    });
  }
  if (["Polygon", "MultiPolygon"].includes(to?.type)) {
    const newTo = polygonToLineString(to as Polygon) as Feature<
      LineString | MultiLineString
    >;
    return distanceHelper(from, newTo.geometry);
  }
  return 0;
}
